<ul class="kpi-help">
  <li>
    <mat-icon class="green">check_circle</mat-icon>
    <div>{{ okLabel }}</div>
  </li>
  <li>
    <mat-icon class="red">cancel</mat-icon>
    <div>{{ koLabel }}</div>
  </li>
  @if (!isRaw) {
    <li>
      <mat-icon class="grey">do_not_disturb_on</mat-icon>
      <div [innerHTML]="excludedLabel"></div>
    </li>
  }
  <li>
    <mat-icon class="grey">pending</mat-icon>
    <div [innerHTML]="'KPI_PENDING_CALCULATION.HELP' | transloco"></div>
  </li>
</ul>
